namespace Gamification.Gamification {
    export interface TipologieCaricamentiRow {
        UserId?: number;
        TenantId?: number;
        IdTipologiaCaricamento?: number;
        Nome?: string;
        Descrizioni?: string;
    }

    export namespace TipologieCaricamentiRow {
        export const idProperty = 'IdTipologiaCaricamento';
        export const nameProperty = 'Nome';
        export const localTextPrefix = 'Gamification.TipologieCaricamenti';
        export const lookupKey = 'Gamification.TipologieCaricamenti';

        export function getLookup(): Q.Lookup<TipologieCaricamentiRow> {
            return Q.getLookup<TipologieCaricamentiRow>('Gamification.TipologieCaricamenti');
        }
        export const deletePermission = 'Gamification:Prodotti';
        export const insertPermission = 'Gamification:Prodotti';
        export const readPermission = 'Gamification:Prodotti';
        export const updatePermission = 'Gamification:Prodotti';

        export declare const enum Fields {
            UserId = "UserId",
            TenantId = "TenantId",
            IdTipologiaCaricamento = "IdTipologiaCaricamento",
            Nome = "Nome",
            Descrizioni = "Descrizioni"
        }
    }
}
